import * as R from "@play-co/replicant";
const webPushActions = R.createActions(R.SB.unknown())({
  internalSetWebPushSubscription: R.action(
    (_state, args, api) => {
      api.chatbot.setWebPushSubscription(args.pushSubscription);
    }
  )
});
function configureWebPushSubscriptionHook(opts) {
  if (opts.gcinstant.platformID !== "web") {
    throw new Error(`Invalid platform: ${opts.gcinstant.platformID}`);
  }
  const platform = opts.gcinstant;
  void opts.replicantClientPromise.then((client) => {
    if (!client.invoke.internalSetWebPushSubscription) {
      throw new Error(
        "No internalSetWebPushSubscription action found. Did you forget to call extendReplicantConfigForAnalytics?"
      );
    }
    const webPushClient = client;
    platform.setPushSubscriptionChangedListener(async (pushSubscription) => {
      await webPushClient.invoke.internalSetWebPushSubscription({
        pushSubscription: pushSubscription == null ? void 0 : pushSubscription.toJSON()
      });
    });
  });
}
export {
  configureWebPushSubscriptionHook,
  webPushActions
};
